<template>
  <div class="relative">
    <div
      class="md:mt-10 lg:mt-10 mt-4 md:py-6 lg:py-6 py-4 md:px-8 lg:px-8 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
      v-for="(item, index) in faq"
      :key="index"
    >
      <div
        class="flex items-center w-full justify-between cursor-pointer"
        block
        v-b-toggle="'accordion-' + index"
      >
        <p class="subtitle txt-FAQ-A fsize20-14px">
          {{ item.que }}
        </p>
        <img
          src="@/assets/images/caregiver/downIcon.svg"
          alt="Downicon"
          class="md:h-4 lg:h-4 h-2 w-6"
        />
      </div>
      <b-collapse
        :id="'accordion-' + index"
        accordion="my-accordion"
        role="tabpanel"
      >
        <p class="subtitle pt-8 fsize20-14px">
          {{ item.answer }}
        </p>
        <p class="subtitle pt-2 fsize20-14px">
          {{ item.answer1 }}
        </p>
        <p class="subtitle pt-2 fsize20-14px">
          {{ item.answer2 }}
        </p>
        <p class="subtitle pt-2 fsize20-14px">
          {{ item.answer3 }}
        </p>
        <p class="subtitle pt-2 fsize20-14px">
          {{ item.answer4 }}
        </p>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      faq: [
        {
          id: "01",
          que: "Module 1",
          answer: "  ⦁	An approach to building Resilience",
          answer1: " ⦁ Building Emotional Infrastructure",
        },
        {
          id: "02",
          que: "Module 2 ",
          answer: "  ⦁ 7 Elements of Wellbeing ",
          answer1: " ⦁ Compassion and Dysfunctional Empathy",
          answer2: " ⦁ Self-Compassion in Caregiving",
          answer3: " ⦁	Stakeholder Mapping for Caregivers",
        },
        {
          id: "03",
          que: "Module 3",
          answer: " ⦁ Addressing Compassion Fatigue",
          answer1: " ⦁ Caregiver Burnout",
          answer2: " ⦁ Reflexivity",
        },
        {
          id: "04",
          que: "Module 4",
          answer: "⦁ Concepts of Emotional Labour ",
          answer1: " ⦁ Emotional Mastery & Emotional First Aid",
          answer2: " ⦁ Building Trust and Psychological Safety",
          answer3: " ⦁ Peer learning  ",
        },
        {
          id: "05",
          que: "Module 5",
          answer: "⦁ Self-care practices ",
          answer1: " ⦁	Concept of Holding space",
          answer2: " ⦁ 	Implications for a Caregiver Coach",
          answer3: " ⦁ 	A demo of a coaching session by the facilitator  ",
          answer4: " ⦁	1:1 coaching session with each participant ",
        },
      ],
    };
  },
};
</script>
